import { render } from "./ModalAgregarComponent.vue?vue&type=template&id=05fd3712&scoped=true"
import script from "./ModalAgregarComponent.vue?vue&type=script&lang=js"
export * from "./ModalAgregarComponent.vue?vue&type=script&lang=js"

import "./ModalAgregarComponent.vue?vue&type=style&index=0&id=05fd3712&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fd3712"]])

export default __exports__